export default "__VITE_ASSET__DJpV2mF6__"